import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  background: white;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  @media only screen and (max-width: 768px) {
    z-index: 1;
    width: 100%;
    height: 100%;
  }
`;
